import { Collection } from 'modules/core/lib/mobx-rest'

import CareersHeader from 'modules/company_page/store/models/CareersHeader'

class CareersHeaders extends Collection<CareersHeader> {
  get cacheKey(): string {
    return 'careersHeaders'
  }

  model() {
    return CareersHeader
  }
}

const singleton: CareersHeaders = new CareersHeaders()

export default singleton
